import { inject, Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly keycloak = inject(Keycloak);

  // Obtener el nombre del operario para mostrar en el Header
  async getUsuarioNombre(): Promise<string> {
    const profile = await this.keycloak.loadUserProfile();
    return `${profile.firstName} ${profile.lastName}`;
  }

  // Cerrar sesión
  logout() {
  
     this.keycloak.logout({
    // window.location.origin enviará al usuario a:
    // http://localhost:4200 (en tu PC)
    // https://inventario.aguapotableplottier.com.ar (en producción)
    redirectUri: window.location.origin,    
    // El método por defecto es GET, que funciona perfecto con Keycloak 26.
    logoutMethod: 'GET' 
  });
  }
}